import { MouseEvent, useRef } from 'react';

import { useLocale } from 'locale';
/*import { useDataContext } from 'context/data-context';*/
import { Container } from 'components/container';
import { VictimsList } from 'components/victims-list';
import { Layout } from 'components/layout';
import { Header, Introduction, Title, VideoContainer, IntroImage } from './styled';
import { FeaturedSlider } from './featured-slider';

export const Home = () => {
  const locale = useLocale();
  const featuredContainerRef = useRef<HTMLDivElement | null>(null);

  const scrollToList = (evt: MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();

    if (featuredContainerRef.current) {
      featuredContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Layout>
      <Header>
        <Container>
          <Title>{locale.title}</Title>
          <Introduction className="underline">{locale.home.intro(scrollToList)}</Introduction>
          {/*<IntroImage>
            <img className="hand" src={process.env.PUBLIC_URL + '/images/hand.png'} />
          </IntroImage>*/}
          <VideoContainer>
            <video autoPlay muted loop playsInline>
              <source src={process.env.PUBLIC_URL + '/video-hand.mp4'} />
            </video>
          </VideoContainer>
          {/*<video autoPlay muted loop playsInline>
            <source src="https://docs.rferl.org/Infographics/2022/2022_07/the-victims-of-kazakstan-unrest/video-svicka.mp4" />
          </video>*/}
        </Container>
      </Header>

      <FeaturedSlider />

      <VictimsList ref={featuredContainerRef} />
    </Layout>
  );
};
